import { ChevronLeftIcon } from '@heroicons/react/16/solid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { eAgendaTabs } from '../Agenda.enums';
import styles from '../agenda.module.scss';
import { useCalendarContext } from './Calendar/Calendar.hook';

export default function TemplateTabMenu(): React.ReactElement {
  const { t } = useTranslation();
  const { setCurrentTab } = useCalendarContext();

  return (
    <div
      onClick={() => setCurrentTab(eAgendaTabs.EVENTS)}
      className="text-primary flex items-center cursor-pointer"
    >
      <ChevronLeftIcon className={styles.IconMd} />
      {t('agenda/agenda:return')}
    </div>
  );
}
